// extracted by mini-css-extract-plugin
module.exports = {"CategoryOverviewArchivePage":"Bestemmingen_CategoryOverviewArchivePage___01ee","CategoryOverview":"Bestemmingen_CategoryOverview__kG540"};